import { createSlice, isAnyOf } from '@reduxjs/toolkit';
import { ITableFiltersParams } from 'core/models/general.models';
import { IBookingDataItem } from '@dashboardWireline/WirelineDepartments/WIrelineDepartament.models';
import {
  getBookingSellerDataRequest,
  getBookingSellerDataSuccess,
  getBookingSellerDataFailure,
  clearBookingSellerDataAction,
} from '@dashboardWirelineSellerDepartment/GetBookingSellerData';
import {
  getBookingReportDataRequest,
  getBookingReportDataSuccess,
  getBookingReportDataFailure,
  clearBookingReportDataAction,
} from '@dashboardWirelineSellerDepartment/GetBookingReportData';

export interface IState {
  count: number
  isLoading: boolean
  error: object | null
  params: ITableFiltersParams
  results: IBookingDataItem[]
}

const initialState: IState = {
  count: 0,
  results: [],
  error: null,
  params: {},
  isLoading: true,
};

const BookingTableDataSlice = createSlice({
  name: 'getBookingTableData',
  initialState,
  reducers: {
    clear: () => initialState,
  },
  extraReducers(builder) {
    builder
      .addMatcher(
        isAnyOf(
          getBookingSellerDataRequest,
          getBookingReportDataRequest,
        ),
        (state, action) => ({
          ...state,
          isLoading: true,
          params: action.payload,
        }),
      )
      .addMatcher(
        isAnyOf(
          getBookingSellerDataSuccess,
          getBookingReportDataSuccess,
        ),
        (state, action) => ({
          ...state,
          ...action.payload,
          isLoading: false,
        }),
      )
      .addMatcher(
        isAnyOf(
          getBookingSellerDataFailure,
          getBookingReportDataFailure,
        ),
        (state, action) => ({
          ...state,
          results: [],
          isLoading: false,
          error: action.payload,
        }),
      )
      .addMatcher(
        isAnyOf(
          clearBookingSellerDataAction,
          clearBookingReportDataAction,
        ),
        () => initialState,
      );
  },
});

export const { clear: clearBookingTableDataAction } = BookingTableDataSlice.actions;

export const getBookingTableDataReducer = BookingTableDataSlice.reducer;
